import { FiInfo } from '@vyaguta/vyaguta-icons/fi';
import React from 'react';

import LFModal from 'components/common/LFModal';

import { interpolate } from 'utils/string';

import { CANCEL, YES_TERMINATE, ENGAGEMENT_STATUS_TERMINATION_CONFIRMATION_MESSAGE } from 'constants/appConstants';

interface TerminationConfirmationModalProps {
  isOpen: boolean;
  title: { text: string; type: string };
  onConfirm: () => void;
  onCancel: () => void;
  firstName: string;
  lastName: string;
}

const TerminationConfirmationModal: React.FC<TerminationConfirmationModalProps> = ({
  isOpen,
  title,
  onConfirm,
  onCancel,
  firstName,
  lastName,
}) => {
  return (
    <LFModal
      isOpen={isOpen}
      renderFooter={true}
      modalStatusIcon={<FiInfo size={18} color="#F44336" className="mtpx-6" />}
      title={title}
      className="delete-modal pr-30 termination-modal"
      buttons={[
        {
          text: YES_TERMINATE,
          type: 'red',
          className: 'mr-12 delete__btn mtpx-8',
          close: true,
          showLoading: true,
          onClick: onConfirm,
        },
        {
          text: CANCEL,
          type: 'outlined-grey',
          className: 'py-8 px-12 mtpx-8',
          onClick: onCancel,
        },
      ]}
      message={{
        text: interpolate(ENGAGEMENT_STATUS_TERMINATION_CONFIRMATION_MESSAGE, {
          firstName: firstName,
          lastName: lastName,
        }),
      }}
    />
  );
};

export default TerminationConfirmationModal;
